import { Typography } from '@mui/material'
import Box from '@mui/material/Box'
import PropTypes from 'prop-types'
import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import SidebarPositionInfo from './SidebarInitActions/SidebarInfo/SidebarPositionInfo'
import SidebarInitActions from './SidebarInitActions/SidebarInitActions'
import SidebarUpdateOpenTrade from './SidebarInitActions/SidebarPendingOrder/SidebarUpdateOpenTrade'
import SidebarUpdatePendingOrder from './SidebarInitActions/SidebarPendingOrder/SidebarUpdatePendingOrder'
import { selectPositionDefaultItem } from '../../../store/redusers/positions/selectors'
import { selectOpenToEditTrade, selectSidebarType } from '../../../store/redusers/sidebar/selectors'
import AppTabs from '../../AppTabs'

function SidebarBody() {
	const sidebarType = useSelector(selectSidebarType)
	const tabs = sidebarType === 'type_asset' ?
		[{ id: 1, label: 'Market execution' }, { id: 2, label: 'Pending Order' }] :
		[{ id: 1, label: 'Basic Info' }, { id: 2, label: 'Trading Hours' }]
	const toUpdateOpenTrade = useSelector(selectOpenToEditTrade)
	const myOpenTrade = useSelector(selectPositionDefaultItem('open', toUpdateOpenTrade))
	const myPendingTrade = useSelector(selectPositionDefaultItem('pending', toUpdateOpenTrade))
	const [isLeftActiveTab, setIsLeftActiveTab] = useState(1)
	const isPositionInfo = sidebarType === 'type_position_info'
	const isUpdateOpen = sidebarType === 'type_open_trade'
	const isUpdatePending = sidebarType === 'type_pending_trade'
	const isTabs = sidebarType === 'type_asset_info' || sidebarType === 'type_asset'

	return (
		<Box sx={{ width: '100%' }}>
			<Box>
				{isTabs ?
					<Box>
						<AppTabs
							setActiveTab={setIsLeftActiveTab}
							tabsArray={tabs}
							defaultActive={tabs[0].id}
							sxCustom={{width: '100%'}}
						/>
						<SidebarInitActions
							isLeftActiveTab={isLeftActiveTab === 1}
							isInfo={sidebarType === 'type_asset_info'}
						/>
					</Box>
					: null}
				{isUpdateOpen && toUpdateOpenTrade && myOpenTrade ?
					<SidebarUpdateOpenTrade toUpdateOpenTrade={toUpdateOpenTrade}/> :
					// eslint-disable-next-line max-len
					(isUpdateOpen && toUpdateOpenTrade ? <Typography variant={'px18'} sx={{m: '0 60px'}}>Trade was closed</Typography> : null)}
				{isUpdatePending && toUpdateOpenTrade && myPendingTrade ?
					<SidebarUpdatePendingOrder toUpdatePendingOrder={toUpdateOpenTrade}/> :
					// eslint-disable-next-line max-len
					(isUpdatePending && toUpdateOpenTrade ? <Typography variant={'px18'} sx={{m: '0 60px'}}>Trade was opened</Typography> : null)}
				{isPositionInfo ? <SidebarPositionInfo/> : null }
			</Box>

		</Box>
	)
}
SidebarBody.propTypes = {
	selectedAssetInfo: PropTypes.bool
}

export default SidebarBody
